export type LocalSqliteOpfsCapability = {
  supported: boolean;
  reason?: string;
};

/** OPFS probe for future wa-sqlite migration (sql.js still uses IndexedDB export today). */
export async function probeLocalSqliteOpfsCapability(): Promise<LocalSqliteOpfsCapability> {
  const getDirectory = navigator.storage?.getDirectory?.bind(navigator.storage);
  if (!getDirectory) {
    return { supported: false, reason: 'navigator.storage.getDirectory unavailable' };
  }
  try {
    await getDirectory();
    return { supported: true };
  } catch (e) {
    return {
      supported: false,
      reason: e instanceof Error ? e.message : String(e),
    };
  }
}
